






































import { Vue, Component, Watch } from 'vue-property-decorator';

import HikariDifferenceBetween1GAnd10GModal from '@/components/Molecules/Modal/HikariDifferenceBetween1GAnd10GModal.vue';
import ModalTextLinkExtension from '@/components/Atoms/Link/ModalTextLinkExtension.vue';
import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import TextLink from '@/components/Atoms/Link/TextLink.vue';
import RadioButtonExtension from '@/components/Atoms/Input/RadioButtonExtension.vue';

@Component({
  components: {
    HikariDifferenceBetween1GAnd10GModal,
    ModalTextLinkExtension,
    TextLink,
    UnorderedList,
    ListItem,
    RadioButtonExtension,
  },
})
export default class ApplyType extends Vue {
  public applyTypeList: {
    id: string;
    value: string;
    text: string;
    disabled: boolean;
  }[] = [
    {
      id: 'applyType_10g',
      value: '10g',
      text: 'ビッグローブ光　10ギガ',
      disabled: false,
    },
    {
      id: 'applyType_1g',
      value: '1g',
      text: 'ビッグローブ光　1ギガ',
      disabled: false,
    },
  ];

  // 申込タイプ
  get applyType(): string {
    return this.$store.getters['hikari/applyType'];
  }
  // 現在ご利用中の回線タイプ
  get currentUsageType(): string {
    return this.$store.getters['hikari/currentUsageType'];
  }
  // 現在ご利用中の回線タイプが変更された場合に検知する
  @Watch('currentUsageType')
  onEntryTypeChanged(newVal: string) {
    this.applyTypeList[1].disabled = (newVal == '10g');
  }

  // 回線タイプが10Gの場合、申込タイプを非活性にする
  get disableApplyType1GFor10G(): boolean {
    return this.currentUsageType === '10g';
  }
}
